// (c) chaehongee. Confidential and proprietary.

import type { ReactElement, ReactNode } from 'react'

import styles from './Tooltip.module.css'

interface TooltipProps {
    /** Bubble contents. Already-localized text or rich nodes. */
    content: ReactNode
    /** Which side the bubble appears on. Defaults to `top`. */
    side?: 'top' | 'bottom'
    /** Extra class for the trigger wrapper. */
    className?: string
    /** Extra class for the bubble (e.g. to widen it). */
    contentClassName?: string
    /** The trigger element(s). */
    children: ReactNode
}

/**
 * Hover/focus tooltip. Wraps a trigger and reveals a bubble on pointer hover
 * and on keyboard focus-within. `side='top'` matches the former `.tooltip`
 * help-icon style; `side='bottom'` matches the former `.buttonTooltip` style.
 */
export function Tooltip({
    content,
    side = 'top',
    className,
    contentClassName,
    children,
}: TooltipProps): ReactElement {
    return (
        <div
            className={className ? `${styles.tooltip} ${className}` : styles.tooltip}
            data-side={side}
        >
            {children}
            <div
                className={
                    contentClassName
                        ? `${styles.content} ${contentClassName}`
                        : styles.content
                }
                role="tooltip"
            >
                {content}
            </div>
        </div>
    )
}

export default Tooltip
